<template>
  <div class="bg-white mt-5 rounded p-3 px-5">
    <div class="w-full flex flex-col md:flex-row border-b py-5 mb-6">
      <div
        class="w-32 h-32 p-4 -mt-20 ml-2 mb-2 text-white rounded-lg relative flex-no-shrink mr-5" :class="page.icon_color ? page.icon_color : 'bg-tertiary'"
      >
        <icon name="videoettes"></icon>
      </div>

      <div class="w-full flex justify-between items-end">
        <h1 class="text-lg self-end mb-3 uppercase font-bold">Branding Pre-sets</h1>
        <div v-if="saving !== null" class="text-lg font-medium">
          <i class="fas fa-spinner fa-pulse fa-lg mr-2"></i>
          Saving your presets
        </div>
      </div>
    </div>

    <div class="pb-4">
      <div class="mb-12">
        <h3 class="mb-2">Video Branding Options</h3>
        <p>Set yout pre-sets here and they will become the defaults for all your branded videos.</p>
      </div>

      <div class="mb-4 pb-8 overflow-x-scroll">
        <tabs
          v-model="tab"
          :options="['Logo Animation', 'Transitions', 'Branding', 'Presenter info', 'Call to Action', 'Backing Music']"
        />
      </div>

      <logo-animation v-if="tab === 'Logo Animation'" v-model="logo" />
      <transitions v-if="tab === 'Transitions'" v-model="transition" />
      <branding v-if="tab === 'Branding'" v-model="branding" />
      <presenter-info v-if="tab === 'Presenter info'" v-model="showPresenter" />
      <call-to-action v-if="tab === 'Call to Action'" v-model="vcta" />
      <backing-music v-if="tab === 'Backing Music'" v-model="musicOptions" />
    </div>
  </div>
</template>

<script>
import Branding from '@/components/Videoettes/Branding'
import BackingMusic from '@/components/Videoettes/BackingMusic'
import LogoAnimation from '@/components/Videoettes/LogoAnimation'
import Transitions from '@/components/Videoettes/Transitions'
import Tabs from '@/components/Videoettes/Tabs'
import Subscription from '@/components/Videoettes/Subscription'
import QuickPresetSelector from '@/components/Videoettes/QuickPresetSelector'
import VideoBrandingCallToAction from '@/components/VideoBranding/VideoBrandingCallToAction'
import CallToAction from '@/components/Videoettes/CallToAction'
import PresenterInfo from '@/components/VideoBranding/PresenterInfo'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'BrandingPreSets',

  props: ['page'],

  components: {
    Tabs,
    Branding,
    BackingMusic,
    LogoAnimation,
    Subscription,
    QuickPresetSelector,
    VideoBrandingCallToAction,
    CallToAction,
    PresenterInfo,
    Transitions
  },

  computed: {
    ...mapState({
      saving: state => state.savingBrandingPresets,
      office: state => state.selectedOffice,
      brandingItems: state => state.videoettes.brandingItems,
      transitionItems: state => state.videoettes.transitionItems,
      preset: state => state.selectedVideoBradingOption
    }),

    vcta () {
      if (!this.office) return { contact: {} }

      return {
        sales: {
          number: this.office.sales_phone,
          email: this.office.sales_email,
          website: this.office.website
        },
        lettings: {
          number: this.office.lettings_phone,
          email: this.office.lettings_email,
          website: this.office.website
        }
      }
    },

    logo: {
      get () {
        return this.preset.logo
      },
      set (val) {
        this.setVideoBrandingLogo(val)
      }
    },

    transition: {
      get () {
        return this.preset.transition
      },
      set (val) {
        this.setVideoBrandingTransition(val)
      }
    },

    branding: {
      get () {
        return this.preset.branding
      },
      set (val) {
        this.setVideoBrandingOption(val)
      }
    },

    showPresenter: {
      get () {
        return this.preset.showPresenter
      },
      set (val) {
        this.setPresenterBrandingOption(val)
      }
    },

    musicOptions: {
      get () {
        return this.preset.backingMusic
      },
      set (val) {
        this.setAudioBradingOption(val)
      }
    }
  },
  methods: {
    ...mapMutations([
      'setVideoBrandingOption',
      'setPresenterBrandingOption',
      'setVideoBrandingLogo',
      'setAudioBradingOption',
      'setVideoBrandingTransition'
    ]),

    storeVideoBradingOption (brandingOption) {
      this.$store.commit('setVideoBrandingOption', brandingOption)
    },
    storeVideoBrandingCallToAction (callToActionoption) {
      this.$store.commit('setVideoBraningCallToAction', callToActionoption.id)
    },
    storeVideoAudioOption (AudioOption) {
      this.$store.commit('setAudioBradingOption', AudioOption.id)
    },
    storeVideoBrandingLogo (logoOption) {
      this.$store.commit('setVideoBrandingLogo', logoOption.id)
    },
    storeVideoBrandingPresenter (presenterOption) {
      this.$store.commit('setPresenterBrandingOption', presenterOption.id)
    }
  },
  data () {
    return {
      tab: 'Logo Animation'
    }
  }
}
</script>
